import {useFormik} from 'formik';
import * as Yup from 'yup';
import {useCreateDocumentVersion} from '../../../entities';
import {useConsentDocumentUpload} from '../lib';
import {AxiosError} from 'axios';

type UseAddDocumentVersionFormProps = {
  documentId: string;
  setOpen: (open: boolean) => void;
  onVersionAdded: () => void;
};

export const useAddDocumentVersionForm = ({documentId, setOpen, onVersionAdded}: UseAddDocumentVersionFormProps) => {
  const createVersionMutation = useCreateDocumentVersion();
  const {uploadId, fileName, fileSize, isUploading, uploadDocument, resetUpload} = useConsentDocumentUpload();

  const onSubmit = async (values: {description: string}) => {
    if (!uploadId) {
      return;
    }

    try {
      await createVersionMutation.mutateAsync({
        documentId,
        dto: {
          uploadId,
          description: values.description || null,
        },
      });

      onVersionAdded();
      resetUpload();
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      description: '',
    },
    validationSchema: Yup.object({
      description: Yup.string().max(500, 'Описание не должно превышать 500 символов'),
    }),
    onSubmit,
  });

  const resetForm = () => {
    formik.resetForm();
    resetUpload();
  };

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    resetForm,
    submitForm: formik.submitForm,
    isLoading: createVersionMutation.isPending || isUploading,
    submitError: createVersionMutation.error
      ? (createVersionMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    // Upload related
    uploadId,
    fileName,
    fileSize,
    isUploading,
    uploadDocument,
    resetUpload,
  };
};
